import {BuType} from "./bu-types";

export class InAppMessage {
  id: string | null;
  title: string | null;
  titles: string[];
  body: string;
  messages: string[];
  labels: string[];
  linkLabel: string | null;
  externalUrl: string | null;
  dismissible: boolean;
  locale: string;
  subscription: string | null;
  versionNumber: string | null;
  versionCondition: number;
  bu: BuType;
  displayRoute: string;
  created: Date;
  startDate: Date | null;
  endDate: Date | null;
  createdBy: string | null;
  type: "active" | "scheduled";
  os: 'Android' | 'iOS' | 'All';

  constructor(id: string | null, title: string | null, titles: string[], body: string, messages: string[], labels: string[], linkLabel: string | null, externalUrl: string | null, dismissible: boolean, locale: string, bu: BuType, displayRoute: string, created: Date, os: 'Android' | 'iOS' | 'All' = 'All') {
    this.id = id;
    this.title = title;
    this.titles = titles;
    this.body = body;
    this.messages = messages;
    this.labels = labels;
    this.linkLabel = linkLabel;
    this.externalUrl = externalUrl;
    this.dismissible = dismissible;
    this.locale = locale;
    this.bu = bu;
    this.displayRoute = displayRoute
    this.created = created;
    this.os = os;
  }
}
